var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.375C5.57812 0.375 0.375 5.625 0.375 12C0.375 18.4219 5.57812 23.625 12 23.625C18.375 23.625 23.625 18.4219 23.625 12C23.625 5.625 18.375 0.375 12 0.375ZM12 21.375C6.79688 21.375 2.625 17.2031 2.625 12C2.625 6.84375 6.79688 2.625 12 2.625C17.1562 2.625 21.375 6.84375 21.375 12C21.375 17.2031 17.1562 21.375 12 21.375ZM13.9688 16.5C13.9688 15.4219 13.0781 14.5312 12 14.5312C10.875 14.5312 10.0312 15.4219 10.0312 16.5C10.0312 17.625 10.875 18.4688 12 18.4688C13.0781 18.4688 13.9688 17.625 13.9688 16.5ZM10.125 6.60938L10.4531 12.9844C10.4531 13.2656 10.7344 13.5 11.0156 13.5H12.9375C13.2188 13.5 13.5 13.2656 13.5 12.9844L13.8281 6.60938C13.8281 6.28125 13.5938 6 13.2656 6H10.6875C10.3594 6 10.125 6.28125 10.125 6.60938Z",
    fill: "#4E9CDF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info.3ad7aa1d.svg";
export { ForwardRef as ReactComponent };